interface OnboardingErrorProps {
    error: string;
    onRetry: () => void;
    retrying?: boolean;
}

export default function OnboardingError({ error, onRetry, retrying = false }: OnboardingErrorProps) {
    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
                {/* Error Icon */}
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100 mb-4">
                    <svg
                        className="h-10 w-10 text-red-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    Connection Issue
                </h3>

                {/* Error Message */}
                <p className="text-base text-gray-600 mb-6 mt-4">
                    {error}
                </p>

                {/* Retry Button */}
                <button
                    type="button"
                    onClick={onRetry}
                    disabled={retrying}
                    className="w-full inline-flex justify-center items-center rounded-lg border border-transparent bg-blue-600 px-6 py-3 text-base font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {retrying ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Retrying...
                        </>
                    ) : (
                        'Try Again'
                    )}
                </button>

                {/* Help Text */}
                <p className="text-sm text-gray-500 mt-4">
                    If the problem persists, please check your internet connection or contact support.
                </p>
            </div>
        </div>
    );
}
